module.exports = __webpack_public_path__ + "img/post.20929bd2.jpg";